import CustomerReferralOkendo from '@sectionsJS/customer-referral-okendo/index.js';

document.addEventListener('DOMContentLoaded', () => {
  new CustomerReferralOkendo();
});
